import { render } from "./TariffList.vue?vue&type=template&id=1d6a9f44"
import script from "./TariffList.vue?vue&type=script&lang=js"
export * from "./TariffList.vue?vue&type=script&lang=js"

import "./TariffList.vue?vue&type=style&index=0&id=1d6a9f44&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__